// Current sensor (DeviceID 82 single-phase, 16 three-phase) — the energy page.
// The same panel the phone shows: ui/shared/energy/EnergyPanel.jsx.

import React from 'react';
import DeviceShell from '../../components/DeviceShell';
import EnergyPanel from '../../../shared/energy/EnergyPanel';

export default function PhaseScreen({ device, phases }) {
  return (
    <DeviceShell title={device.DeviceName || device.UniqueNumber}>
      <EnergyPanel device={device} phaseCount={phases === 3 ? 3 : 1} />
    </DeviceShell>
  );
}
